import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { List } from "immutable";
import { removeSnackbar } from "../stores/app_s";
import MuiSnackbar from "@mui/material/Snackbar";
import Alert from '@mui/material/Alert';

function Snackbar(props) {
    const dispatch = useDispatch();

    const message = useSelector((state) =>
        state.app.getIn(["notifications", 0, "message"], "")
    );

    const variant = useSelector((state) =>
        state.app.getIn(["notifications", 0, 'options', "variant"], "")
    );

    const onClose = () => {
        dispatch(removeSnackbar());
    };

    return (
        <MuiSnackbar
            open={message ? true : false}
            autoHideDuration={2000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={onClose}
        >
            <Alert
                // onClose={onClose}
                variant="filled"
                severity={variant}
                sx={{ width: '100%'}}
            >
                {message}
            </Alert>
            
        </MuiSnackbar>
    );
}
export default Snackbar;
